import React, { useState } from 'react';
import { Home, Users, FileText, Receipt, Plus, X, UserPlus, FilePlus } from 'lucide-react';

const AdminBottomNavbar = ({ 
    activeTab, 
    setActiveTab, 
    onNewClient, 
    onNewQuote, 
    onNewInvoice 
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const navItems = [
        { id: 'dashboard', label: 'Dashboard', icon: Home },
        { id: 'customers', label: 'Clients', icon: Users },
        { id: 'center', label: '', icon: Plus }, // Placeholder for central button
        { id: 'quotes', label: 'Devis', icon: FileText },
        { id: 'invoices', label: 'Factures', icon: Receipt },
    ];

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const handleAction = (actionFn) => {
        setIsMenuOpen(false);
        actionFn();
    };

    return (
        <div className="admin-bottom-nav-wrapper">
            {/* Quick Action Overlay Menu */}
            {isMenuOpen && (
                <div className="action-menu-overlay" onClick={() => setIsMenuOpen(false)}>
                    <div className="action-menu-content" onClick={e => e.stopPropagation()}>
                        <button className="action-menu-item" onClick={() => handleAction(onNewClient)}>
                            <div className="action-icon client"><UserPlus size={20} /></div>
                            <span>Nouveau Client</span>
                        </button>
                        <button className="action-menu-item" onClick={() => handleAction(onNewQuote)}>
                            <div className="action-icon quote"><FilePlus size={20} /></div>
                            <span>Nouveau Devis</span>
                        </button>
                        <button className="action-menu-item" onClick={() => handleAction(onNewInvoice)}>
                            <div className="action-icon invoice"><Receipt size={20} /></div>
                            <span>Nouvelle Facture</span>
                        </button>
                    </div>
                </div>
            )}

            <div className="admin-bottom-navbar">
                <div className="bottom-nav-container">
                    {navItems.map((item) => {
                        if (item.id === 'center') {
                            return (
                                <div key={item.id} className="nav-item-center">
                                    <button 
                                        className={`action-toggle-btn ${isMenuOpen ? 'open' : ''}`}
                                        onClick={toggleMenu}
                                    >
                                        {isMenuOpen ? <X size={28} /> : <Plus size={28} />}
                                    </button>
                                </div>
                            );
                        }

                        return (
                            <button 
                                key={item.id} 
                                className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
                                onClick={() => setActiveTab(item.id)}
                            >
                                <item.icon size={22} />
                                <span>{item.label}</span>
                            </button>
                        );
                    })}
                </div>
            </div>

            <style jsx>{`
                .admin-bottom-nav-wrapper {
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    z-index: 990;
                    display: none;
                }

                @media (max-width: 991px) {
                    .admin-bottom-nav-wrapper {
                        display: block;
                    }
                }

                .admin-bottom-navbar {
                    background: rgba(255, 255, 255, 0.95);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    border-top: 1px solid rgba(0, 0, 0, 0.08);
                    height: 65px;
                    padding-bottom: env(safe-area-inset-bottom);
                }

                .bottom-nav-container {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    height: 100%;
                    max-width: 600px;
                    margin: 0 auto;
                }

                .nav-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    background: none;
                    border: none;
                    color: #64748b;
                    flex: 1;
                    padding: 8px 0;
                    gap: 4px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .nav-item span {
                    font-size: 0.65rem;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.3px;
                }

                .nav-item.active {
                    color: #2563eb;
                }

                .nav-item-center {
                    width: 70px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    position: relative;
                }

                .action-toggle-btn {
                    position: absolute;
                    top: -20px;
                    width: 56px;
                    height: 56px;
                    background: linear-gradient(135deg, #0EA5E9 0%, #2563EB 100%);
                    border-radius: 50%;
                    border: 4px solid #fff;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
                    cursor: pointer;
                    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    z-index: 991;
                }

                .action-toggle-btn.open {
                    transform: rotate(90deg);
                    background: #f1f5f9;
                    border-color: #fff;
                    color: #1e293b;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                }

                /* Popup Menu Styles */
                .action-menu-overlay {
                    position: fixed;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: rgba(0, 0, 0, 0.2);
                    backdrop-filter: blur(2px);
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: center;
                    padding-bottom: 85px;
                    z-index: 992;
                    animation: fadeIn 0.2s ease;
                }

                .action-menu-content {
                    background: #ffffff;
                    width: 92%;
                    max-width: 320px;
                    border-radius: 24px;
                    padding: 8px;
                    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
                    border: 1px solid rgba(0, 0, 0, 0.05);
                    animation: slideUp 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                }

                .action-menu-item {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    padding: 14px 18px;
                    background: none;
                    border: none;
                    color: #1e293b;
                    font-weight: 600;
                    font-size: 0.95rem;
                    cursor: pointer;
                    border-radius: 16px;
                    transition: background 0.2s;
                }

                .action-menu-item:hover {
                    background: #f8fafc;
                }

                .action-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                }

                .action-icon.client { background: #8b5cf6; }
                .action-icon.quote { background: #3b82f6; }
                .action-icon.invoice { background: #10b981; }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
            `}</style>

            <style jsx global>{`
                @media (max-width: 991px) {
                    body.admin-style {
                        padding-bottom: calc(65px + env(safe-area-inset-bottom)) !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default AdminBottomNavbar;
